 
//export const base_url = 'https://alhudademo.integratesolu.com/';
//export const base_url = 'http://localhost:3000/';
export const base_url = 'https://demo.alhudabutchery.com/';
//export const api_base_url = 'https://alhuda.integratesolu.com/public/api/';
export const api_base_url = 'https://admin.alhudabutchery.com/public/api/';